import React, { ReactNode } from 'react';

import { cx } from '@emotion/css';

type TitleAndDescProps = {
  title?: string;
  subTitle?: string;
  description?: ReactNode;
  descriptions?: string[];
  styles: any;
};

export const TitleAndDescComponent = (props: TitleAndDescProps) => {
  const { title, description, descriptions, styles, subTitle } = props;

  return (
    <div className={cx(styles.heading_wraper, styles.root)}>
      {title !== '' && (
        <h1 className={cx(styles.site_title, styles.h1)}>{title}</h1>
      )}
      {subTitle !== '' && (
        <h3 className={cx(styles.site_title, styles.h3)}>{subTitle}</h3>
      )}
      {descriptions && descriptions.length > 0
        ? descriptions.map((desc, i) => (
            <React.Fragment key={i}>
              <p className={cx(styles.heading_wraper_p, styles.p)}>{desc}</p>
              <br />
            </React.Fragment>
          ))
        : description && (
            <p className={cx(styles.heading_wraper_p, styles.p)}>{description}</p>
          )}
    </div>
  );
};
